// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._5kI6iIAq4rDp8ejhX6Rg {\n    background-color: white;\n    padding: 16px;\n    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);\n    border-radius: 4px;\n}\n\n._1C4nVhLB6GIoYOXBPZ_Acm {\n    background-color: white;\n    padding: 30px 36px;\n    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);\n    border-radius: 4px;\n}\n\n._1C4nVhLB6GIoYOXBPZ_Acm h1 {\n    font-weight: 600;\n    -webkit-font-smoothing: antialiased;\n}\n\n@media screen and (min-width: 700px) {\n    ._1C4nVhLB6GIoYOXBPZ_Acm {\n        margin: 0px 50px 0;\n        border-radius: initial;\n    }\n\n    ._5kI6iIAq4rDp8ejhX6Rg {\n        margin: 0 50px 0;\n        border-radius: initial;\n    }\n\n    ._1WChPmmIBLfp8mOW3b5xhC {\n        height: 100px;\n    }\n}\n", ""]);
// Exports
exports.locals = {
	"card": "_5kI6iIAq4rDp8ejhX6Rg",
	"containerCard": "_1C4nVhLB6GIoYOXBPZ_Acm",
	"headerSpacer": "_1WChPmmIBLfp8mOW3b5xhC"
};
module.exports = exports;
